import { Box, Text } from 'ink';
import ProgressBar from './ProgressBar';

export default function Preparation({
  progressPercentage,
  stageLabel,
  uploadedSize,
}: {
  progressPercentage: number;
  stageLabel: string;
  uploadedSize?: string;
}) {
  return (
    <Box marginBottom={1}>
      <Text>{stageLabel}: </Text>
      <Box flexDirection="column">
        <ProgressBar left={11} percent={progressPercentage} />
        {uploadedSize ? <Text>{uploadedSize}</Text> : undefined}
      </Box>
    </Box>
  );
}
